import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

let similarVacanciesSwiperWr = document.querySelectorAll('.similar-vacancies-swiper-wr');

similarVacanciesSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let parentEl = el.parentElement;
    let nextEl = parentEl.querySelector('.swiper-button-next');
    let prevEl = parentEl.querySelector('.swiper-button-prev');

    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation],
      slidesPerView: 1,
      spaceBetween: 16,
      threshold: 10,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl,
        prevEl,
      },
      breakpoints: {
        480: {
          slidesPerView: 1.4,
          spaceBetween: 16,
        },
        640: {
          slidesPerView: 1.8,
          spaceBetween: 18,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 18,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
    });

    swiperObserver(swiper);
  }
});
